module.exports = __webpack_public_path__ + "img/45.226d36bd.jpg";